import Cookies from "js-cookie";
// @ts-expect-error
import { COOKIES_REFRESH_TOKEN_KEY, COOKIES_TOKEN_KEY } from "../../../../modules/API";
import { parseURLParams } from "./parseURLParams";
import { browser } from "../lib-jitsi-meet";
function checkFallbackLocalstorage() {
    return window?.self !== window?.top || browser?.isElectron();
}
const defaultCookiesOptions = {
    domain: getDomainCookies(),
    expires: 365,
    secure: true,
};
function getDomainCookies() {
    if (window.location.hostname.includes("127.0.0.1") || window.location.hostname.includes("localhost")) {
        return window.location.hostname;
    }
    const domainSplit = window.location.hostname.split('.');
    return `${domainSplit[domainSplit.length - 2]}.${domainSplit[domainSplit.length - 1]}`;
}
export const setCookies = (key, value, options) => {
    Cookies.set(key, value, options);
    if (typeof value === 'string' && checkFallbackLocalstorage())
        localStorage.setItem(key, value);
};
export const getCookies = (key) => {
    return Cookies.get(key) || (checkFallbackLocalstorage() && localStorage.getItem(key));
};
export const removeCookies = (key, options) => {
    Cookies.remove(key, options);
};
export const setAccessToken = (accessToken) => {
    setCookies(COOKIES_TOKEN_KEY, accessToken, defaultCookiesOptions);
};
export const setRefreshToken = (refreshToken) => {
    try {
        APP.API.notifyChangeToken(refreshToken);
    }
    catch (error) {
        console.log('error', error);
    }
    setCookies(COOKIES_REFRESH_TOKEN_KEY, refreshToken, defaultCookiesOptions);
};
export const setTokens = (accessToken, refreshToken) => {
    setRefreshToken(refreshToken);
    setAccessToken(accessToken);
};
export const getAccessToken = () => {
    return getCookies(COOKIES_TOKEN_KEY);
};
export const getRefreshToken = () => {
    return getCookies(COOKIES_REFRESH_TOKEN_KEY);
};
export const getTokens = () => {
    const accessToken = getAccessToken();
    const refreshToken = getRefreshToken();
    return { accessToken, refreshToken };
};
export const clearAccessToken = () => {
    removeCookies(COOKIES_TOKEN_KEY, defaultCookiesOptions);
};
export const clearRefreshToken = () => {
    removeCookies(COOKIES_REFRESH_TOKEN_KEY, defaultCookiesOptions);
};
export const clearTokens = () => {
    clearRefreshToken();
    clearAccessToken();
};
export const getConfigAutoGuest = () => {
    const autoGuestUrl = parseURLParams(window.location, true, 'hash')['config.autoGuest'];
    const { autoGuest } = APP.store.getState()['features/base/config'];
    if (autoGuestUrl)
        return decodeURIComponent(autoGuestUrl).replace(/[''""]/g, '') || autoGuest;
    return autoGuest;
};
